// @ts-strict-ignore
import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { routes } from '~/helpers/routes';
import { useGetCustomers } from '~/dashboard/admin/provisioning/helpers/useGetCustomers';
import { UserContext } from '~/dashboard/context';
import type { CustomerData } from '~/dashboard/admin/provisioning/types';

export const useReturnToAdminDashboard = () => {
  const { agent, customer } = useContext(UserContext);

  const [isRunning, setIsRunning] = useState(false);

  const {
    data: { customers } = { cells: {}, customers: [] as CustomerData[] },
    isLoading,
  } = useGetCustomers();

  let baseUrl: string;
  if (agent.isEmployee) {
    baseUrl = customers.find(c => c.organization_name_slug === customer.organizationNameSlug)
      ?.app?.base_url ?? '';
  } else {
    baseUrl = customers.find(c => c.is_parent_organization)
      ?.app?.url ?? '';
  }

  const changeLocation = useCallback(() => {
    const path = routes.v3.dashboard.admin.customers.list;
    setIsRunning(false);
    window.location.assign(`${baseUrl}${path}`);
  }, [baseUrl]);

  const returnToAdminDashboard = useCallback(() => setIsRunning(true), []);

  useEffect(() => {
    if (!isRunning || isLoading) return;
    changeLocation();
  }, [isRunning, changeLocation, isLoading]);

  return { returnToAdminDashboard, isLoading: isLoading && isRunning };
};
